module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1508_-f2fa14db95bc01f2ff9d5e9bfe9b0c04.png";